import { defineStore } from 'pinia'

export const useNewsStoreMSN = defineStore('newsStoremsn', {
  state: () => ({
    all_fetched_on: null,
    All: null,

    Sports_fetched_on: null,
    Sports: null,

    Money_fetched_on: null,
    Money: null,

    Shopping_fetched_on: null,
    Shopping: null,

    Lifestyle_fetched_on: null,
    Lifestyle: null,

    News_fetched_on: null,
    News: null,

    Travel_fetched_on: null,
    Travel: null,

    Health_fetched_on: null,
    Health: null,

    Automotive_fetched_on: null,
    Automotive: null,
  }),
  persistedState: {
    persist: true,
  },
})
